import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { combineLatest } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';
import { Guid } from '../utils/guid';
import { ConfigAction } from './actions/config.action';

export class ConfigStateModel {
  messages = {} as any;
  urls = {} as any;
  appVersion = {} as any;
  release = {} as any;
}

@State<ConfigStateModel>({
  name: 'config',
  defaults: new ConfigStateModel(),
})
@Injectable()
export class ConfigState {
  constructor(private config: ConfigService) {}

  @Action(ConfigAction.Init)
  onInitConfig(ctx: StateContext<ConfigStateModel>, action: ConfigAction.Init) {
    return combineLatest([
      this.config.getConfig(),
      this.config.getMessages(),
    ]).pipe(
      tap(([config, messages]) => {
        const appVersionFromConfig = `${config.appVersion.major}.${config.appVersion.minor}.${config.appVersion.runNumber}`;

        const appVersionFromLocalStorage = localStorage.getItem('appVersion');

        if (appVersionFromLocalStorage != appVersionFromConfig) {
          const expiryDate = new Date();
          expiryDate.setDate(new Date().getDate() + 2);
          localStorage.setItem('appVersion', appVersionFromConfig);
          localStorage.setItem('appReleaseSeenDate', new Date().toISOString());
          localStorage.setItem(
            'releaseBannerExpiryDate',
            expiryDate.toISOString()
          );
          localStorage.setItem('isBannerDismissed', '0');
        }

        const releaseBannerExpiryDate = localStorage.getItem(
          'releaseBannerExpiryDate'
        );
        const isBannerDismissed = localStorage.getItem('isBannerDismissed');

        if (
          releaseBannerExpiryDate &&
          isBannerDismissed == '0' &&
          new Date(releaseBannerExpiryDate) > new Date()
        ) {
          const releaseNoteMessage = {
            icon: 'info',
            mode: 'info',
            type: 'release',
            guid: Guid.newGuid(),
            expiry: new Date(releaseBannerExpiryDate).toISOString(),
            description:
              'A new version of the Court Case Management Digital Service has been released. ',
            viewIndex: '2',
          };

          ctx.patchState({
            release: releaseNoteMessage,
          });
        } else {
          ctx.patchState({
            release: undefined,
          });
        }

        ctx.patchState({
          urls: config.urls,
          messages: messages,
          appVersion: config.appVersion,
        });
        ctx.dispatch(action.callback);
      })
    );
  }

  @Action(ConfigAction.DismissRelease)
  onDismissRelease(
    ctx: StateContext<ConfigStateModel>,
    action: ConfigAction.DismissRelease
  ) {
    ctx.patchState({
      release: undefined,
    });

    localStorage.setItem('isBannerDismissed', '1');
  }
}
